import { PROGRAM_TITLE_COMCAST } from './program.constants';

// Comcast Program Variables
export const comcastVariables: any = {
    programTitle: PROGRAM_TITLE_COMCAST,
    effectiveDates: "1/1/2027 - 1/1/2028",
    feeDisclaimer: "All Premiums are subject to 3% Pennsylvania Surplus Lines Tax (not included in below premiums).",
    policyUrl: "../../../assets/umbrella/Comcast/Chubb_GPEL_Policy.pdf",
    faqUrl: "../../../assets/umbrella/Comcast/Group-Personal-Excess-Liability-FAQs.pdf",
    EL_Items: [
        "Comcast_EL_Header",
        ["Comcast_EL_1M", "$1,000,000", "$1,107.00"],
        ["Comcast_EL_2M", "$2,000,000", "$1,527.00"],
        ["Comcast_EL_3M", "$3,000,000", "$1,778.00"],
        ["Comcast_EL_5M", "$5,000,000", "$2,255.00"],
        ["Comcast_EL_10M", "$10,000,000*", "$3,400.00"],
        ["Comcast_EL_15M", "$15,000,000**", "$7,391.00"],
        ["Comcast_EL_20M", "$20,000,000**", "$10,448.00"],
        ["Comcast_EL_25M", "$25,000,000**", "$13,864.00"],
        ["Comcast_EL_30M", "$30,000,000**", "$16,137.00"]
    ],
    EL_Disclaimers: [
        "<strong>*</strong>The maximum limit of liability for any participants without their underlying home and auto insurance policies in place with Chubb.",
        `<strong>**</strong>It is a requirement that any participant who <u>newly elects or enrolls</u> at these limits have their underlying home and auto insurance policies in place with Chubb and complete the Group Personal Excess Participants Questionnaire. These limits are subject to prior underwriting approval.  These requirements have been waived for current participants renewing at their expiring limit.`

    ],
    UM_Items: [
        "Comcast_UM_Header",
        ["Comcast_UM_1M", "$1,000,000", "Included above"],
        ["Comcast_UM_2M", "$2,000,000", "$232.00"],
        ["Comcast_UM_3M", "$3,000,000", "$497.00"],
        ["Comcast_UM_5M", "$5,000,000", "$1,022.00"],
        ["Comcast_UM_10M", "$10,000,000", "$2,326.00"]
    ],
    UM_Disclaimers: ["*The UM/UIM limit cannot be higher than the liability limit."],
    EPLI_Items: [
        "Comcast_EP_Header",
        ["Comcast_EP_Decline", "By selecting this box, I am declining EPLI Insurance."],
        ["Comcast_EP_250K", "$250,000 per occurrence / $500,000 aggregate*", "$10,000", "$1,531.00"],
        ["Comcast_EP_500K", "$500,000 per occurrence / $500,000 aggregate*", "$10,000", "$2,296.00"]
    ],
    EPLI_Disclaimer: "<strong>*</strong>*Any participant who newly <u>elects</u> this coverage is required to complete the Chubb Employment Practice Liability Coverage Request Worksheet.",
    CI_Items: [
        "Comcast_PR_Parent",
        "Comcast_PR_Yes",
        "Comcast_PR_No"
    ]
};
